// ==================== PlannedLeaves.jsx ====================
import React, { useEffect, useState } from "react";
import "../Styling/PlannedLeaves.css";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { CalendarDays } from "lucide-react";
import axios from "axios";

const PlannedLeaves = ({ filters }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const userId = user?.userId;

  const orgId = filters?.orgId || user?.organisationId;
  const companyCode = filters?.companyCode || user?.companyCode || "";
  const fiscalYear = filters?.fiscalYear || "All Fiscal Years";

  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!orgId) return;

    const fetchLeaves = async () => {
      try {
        setLoading(true);

        const params = new URLSearchParams();

        // optional filters
        if (companyCode) {
          params.append("companyCode", companyCode);
        }

        if (
          fiscalYear &&
          fiscalYear !== "All Fiscal Years"
        ) {
          params.append("fiscalYear", fiscalYear);
        }

        const response = await fetch(
          `${Base_URL}/Leave/GetLeavesForNext10Days/${orgId}?userId=${user?.userId}`
        );

        const result = await response.json();



        const leavesData = Array.isArray(result)
          ? result
          : result?.data || [];

        setLeaves(leavesData);
      } catch (err) {
        console.error("❌ Planned leaves error:", err);
        setLeaves([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaves();
  }, [orgId, companyCode, fiscalYear]);

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleDateString(
      "en-IN",
      {
        day: "2-digit",
        month: "short",
      }
    );
  };

  const handleViewLeaves = async () => {
    try {
      const response = await axios.get(
        `${Base_URL}/OrgObjectActivityUrl/GetActivityUrl`,
        {
          params: {
            OrgID: user?.organisationId,
            objectName: "Request Leave",
            activityName: "Approve",
          },
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      const url = response?.data?.Url;

      if (url) {
        navigate(url);
      } else {
        navigate("/view-leaves");
      }
    } catch (error) {
      console.error(
        "Error fetching activity URL:",
        error
      );

      // fallback
      navigate("/view-leaves");
    }
  };

  return (
    <div className="plv-card">
      <div className="plv-header">
        <div className="plv-header-left">
          <div className="plv-icon">
            <CalendarDays size={18} />
          </div>

          <h6 className="plv-title">
            Planned Leaves
          </h6>
        </div>

        <span
          className="plv-view-all"
          onClick={handleViewLeaves}
        >
          View all
        </span>
      </div>

      {loading && (
        <p className="plv-empty plv-muted">
          Loading upcoming leaves…
        </p>
      )}

      {!loading && leaves.length === 0 && (
        <p className="plv-empty">
          No upcoming leaves
        </p>
      )}
<div className="plv-list">
      {!loading &&
        leaves.map((item, idx) => {

          const leaveDate =
            item.leaveDate ||
            item.leaveStartDate;

          const leaveType =
            item.leaveType ||
            item.Description ||
            "-";

          const resource =
            item.resource ||
            item.Resource_name ||
            "-";

          const department =
            item.department ||
            item.Department ||
            "-";

          return (
            <div
              className="plv-row"
              key={idx}
            >
              <div className="plv-date">
                {formatDate(leaveDate)}
              </div>

              <div className="plv-info">
                <div className="plv-name">
                  {resource}
                </div>

                <div className="plv-dept">
                  {department}
                </div>
              </div>

              <span className="plv-type">
                {leaveType}
              </span>
            </div>
          );
        })}
        </div>
    </div>
  );
};

export default PlannedLeaves;